import Vue from "vue";

import utils from "./utils";
import params from "./params";

const apiUrl = params.getParameterValue("API_URL");
const loginUrl = params.getParameterValue("API_URL");
const loggerUrl = params.getParameterValue("LOGGER_URL");
const uiUrl = params.getParameterValue("UI_URL");

export default {
  login(user, customApiUrl) {
    let url = `${loginUrl}/api/WBUsers/login`;
    if (customApiUrl) {
      url = `${customApiUrl}WBUsers/login`;
    }
    return utils.post(url, [], user);
  },
  logout(customApiUrl) {
    let url = `${loginUrl}/api/WBUsers/logoutUser`;
    if (customApiUrl) {
      url = `${customApiUrl}WBUsers/logoutUser`;
    } else {
      utils.get(`${loginUrl}/auth/openid/logout`, []);
    }
    return utils.post(url, [], []);
  },
  forgotPassword(email, customApiUrl) {
    const creds = {
      email,
      location: uiUrl,
    };
    let url = `${apiUrl}/api/WBUsers/reset`;
    if (customApiUrl) {
      url = `${customApiUrl}WBUsers/reset`;
    }
    return utils.post(url, [], creds);
  },
  resetPassword(password, token, customApiUrl) {
    let urlString = `${apiUrl}/api/WBUsers/passwordReset`;
    if (customApiUrl) {
      urlString = `${customApiUrl}WBUsers/passwordReset`;
    }
    let params = [];
    params.push({ key: "access_token", value: token });

    for (let i = 0; i < params.length; i++) {
      i === 0 ? (urlString += "?") : (urlString += "&");

      urlString += `${params[i].key}=${params[i].value}`;
    }

    return new Promise((resolve, reject) => {
      Vue.http.post(urlString, { password }).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  changePassword(userId, oldPassword, newPassword, customApiUrl) {
    let url = `${apiUrl}/api/WBUsers/changePassword`;
    if (customApiUrl) {
      urlString = `${customApiUrl}WBUsers/changePassword`;
    }
    return utils.post(url, [], { userId, oldPassword, newPassword });
  },
  validateOldPassword(oldPassword) {
    const url = `${apiUrl}/api/WBUsers/validateOldPassword`;
    return utils.get(url, [{ key: "oldPassword", value: oldPassword }]);
  },
  validatePassword(password) {
    const url = `${apiUrl}/api/WBUsers/validateNewPassword`;
    return utils.get(url, [{ key: "password", value: password }]);
  },
  validateUsername(email, username) {
    const url = `${apiUrl}/api/WBUsers/validateNewUsername`;
    return utils.get(url, [
      { key: "email", value: email },
      { key: "username", value: username },
    ]);
  },
  validateFullName(fullName) {
    const url = `${apiUrl}/api/WBUsers/validateFullName`;
    return utils.get(url, [{ key: "fullName", value: fullName }]);
  },
  validateToken() {
    const url = `${apiUrl}/api/WBUsers/validateToken`;
    return utils.get(url, []);
  },
  checkActivateKeyEmail(email, key) {
    const url = `${apiUrl}/api/WBUsers/validateParameters`;
    return utils.get(url, [
      { key: "key", value: key },
      { key: "email", value: email },
    ]);
  },
  getDescriptionValues(email, key) {
    const url = `${apiUrl}/api/WBUsers/activationDetails`;
    return utils.get(url, [
      { key: "key", value: key },
      { key: "email", value: email },
    ]);
  },
  activateUser(newUser) {
    const url = `${apiUrl}/api/WBUsers/activate`;
    return utils.post(url, [], newUser);
  },
  resendKey(email) {
    const url = `${apiUrl}/api/WBUsers/resendKey`;
    return utils.post(url, [], { email: email });
  },
  getUser(id) {
    const url = `${loginUrl}/api/WBUsers/${id}`;
    return utils.get(url, [
      { key: "filter[include]", value: "appAssignments" },
      { key: "filter[include]", value: "team" },
    ]);
  },
  getAssignments() {
    const url = `${apiUrl}/api/WBApps/user/assignments`;
    return utils.get(url, []);
  },
  createUserTeamAssignments(data) {
    const url = `${apiUrl}/api/UserTeamAssignments`;
    return utils.post(url, [], data);
  },
  getUserTeamAssignments() {
    const url = `${apiUrl}/api/UserTeamAssignments`;
    return utils.get(url, []);
  },
  updateUserTeamAssignments(data) {
    const url = `${apiUrl}/api/UserTeamAssignments`;
    return utils.put(url, [], data);
  },
  deleteUserTeamAssignments(id) {
    const url = `${apiUrl}/api/UserTeamAssignments`;
    return utils.delete(url, id);
  },
  getApps() {
    const url = `${apiUrl}/api/WBApps/user/apps`;
    return utils.get(url, []);
  },
  getGroupedApps() {
    const url = `${apiUrl}/api/WBApps/user/apps/grouped`;
    return utils.get(url, []);
  },
  getAppGroups() {
    const url = `${apiUrl}/api/WBAppGroups`;
    return utils.get(url, []);
  },
  createAppGroup(data) {
    const url = `${apiUrl}/api/WBAppGroups`;
    return utils.post(url, [], data);
  },
  updateAppGroup(data) {
    const url = `${apiUrl}/api/WBAppGroups`;
    return utils.put(url, [], data);
  },
  deleteAppGroup(id) {
    const url = `${apiUrl}/api/WBAppGroups/${id}`;
    return utils.delete(url, []);
  },
  getUserStatuses() {
    const url = `${apiUrl}/api/WBUsers/allStatuses`;
    return utils.get(url, []);
  },
  getUsers() {
    const url = `${apiUrl}/api/WBUsers/instance`;
    return utils.get(url, [{ key: "filter[include]", value: "team" }]);
  },
  getUserLogs() {
    const url = `${loggerUrl}api/eventsLogs/getPersonalLog`;
    return utils.get(url, []);
  },
  updateUser(user) {
    const url = `${apiUrl}/api/WBUsers/instance`;
    return utils.put(url, [], user);
  },
  updateUserTeams(data) {
    const url = `${apiUrl}/api/Teams/user/assign`;
    return utils.post(url, [], data);
  },
  updateTeamsAssignment(data) {
    const url = `${apiUrl}/api/Teams/child/assign`;
    return utils.post(url, [], data);
  },
  deleteUser(id) {
    const url = `${apiUrl}/api/WBUsers/instance`;
    return utils.delete(url, id);
  },
  deleteUserTeam(data) {
    const url = `${apiUrl}/api/Teams/user/unassign`;
    return utils.post(url, [], data);
  },
  deleteFromParentTeam(data) {
    const url = `${apiUrl}/api/Teams/child/unassign`;
    return utils.post(url, [], data);
  },
  getRoles(id) {
    let url = "";
    let params = [];
    if (id) {
      url = `${apiUrl}/api/WBApps/roles`;
      params.push({ key: "appId", value: id });
    } else {
      url = `${apiUrl}/api/UserAppAssignments`;
      params.push({
        key: "filter",
        value: "%7B%22include%22%3A[%22app%22,%22user%22]%7D",
      });
    }
    return utils.get(url, params);
  },
  createUserFromApp(user) {
    const url = `${apiUrl}/api/WBUsers/createFromApp`;
    return utils.post(url, [], user);
  },
  createUserFromQuinyxApp(user) {
    const url = `${apiUrl}/api/WBUsers/createActivatedUser`;
    return utils.post(url, [], user);
  },
  createApp(app) {
    const url = `${apiUrl}/api/WBApps`;
    return utils.post(url, [], app);
  },
  updateApp(app) {
    const url = `${apiUrl}/api/WBApps`;
    return utils.put(url, [], app);
  },
  deleteApp(app) {
    const url = `${apiUrl}/api/WBApps`;
    return utils.delete(url, app.id);
  },
  createRole(role) {
    const url = `${apiUrl}/api/UserAppAssignments`;
    return utils.post(url, [], role);
  },
  updateRole(role) {
    const url = `${apiUrl}/api/UserAppAssignments`;
    return utils.put(url, [], role);
  },
  deleteRole(role) {
    const url = `${apiUrl}/api/UserAppAssignments`;
    return utils.delete(url, role.id);
  },
  getOrganisationById(id) {
    const url = `${apiUrl}/api/Organizations/${id}`;
    return utils.get(url, []);
  },
  getOrganizations() {
    const url = `${apiUrl}/api/Organizations`;
    return utils.get(url, []);
  },
  createOrganization(organization) {
    const url = `${apiUrl}/api/Organizations`;
    return utils.post(url, [], organization);
  },
  updateOrganization(organization) {
    const url = `${apiUrl}/api/Organizations`;
    return utils.put(url, [], organization);
  },
  deleteOrganization(organization) {
    const url = `${apiUrl}/api/Organizations`;
    return utils.delete(url, organization.id);
  },
  getOrganizationAssignments() {
    let params = [];
    const url = `${apiUrl}/api/UserOrganizationAssignments`;
    params.push({
      key: "filter",
      value: "%7B%22include%22%3A[%22organization%22,%22user%22]%7D",
    });
    return utils.get(url, params);
  },
  createOrganizationAssignment(organizationAssignment) {
    const url = `${apiUrl}/api/UserOrganizationAssignments`;
    return utils.post(url, [], organizationAssignment);
  },
  updateOrganizationAssignment(organizationAssignment) {
    const url = `${apiUrl}/api/UserOrganizationAssignments`;
    return utils.put(url, [], organizationAssignment);
  },
  deleteOrganizationAssignment(organizationAssignment) {
    const url = `${apiUrl}/api/UserOrganizationAssignments`;
    return utils.delete(url, organizationAssignment.id);
  },
  allowedOrganizationsAndAlgorithmUsers: function () {
    const url = `${apiUrl}/api/organizations/allowedOrganizationsAndAlgorithmUsers`;
    return utils.get(url, []);
  },
  getTeams() {
    const url = `${apiUrl}/api/Teams/getList`;
    return utils.get(url, []);
  },
  getTeamById(teamId) {
    const url = `${apiUrl}/api/Teams/${teamId}`;
    return utils.get(url, []);
  },
  getAssignedTeams() {
    const url = `${apiUrl}/api/TeamChildAssignments`;
    return utils.get(url, []);
  },
  createAuth0Audience: function (data) {
    const url = `${apiUrl}/api/WBApps/createAuth0Audience`;
    return utils.post(url, [], data);
  },
  deleteAuth0Audience: function (data) {
    const url = `${apiUrl}/api/WBApps/deleteAuth0Audience`;
    return utils.delete(url, [], data);
  },
  getHighestUsedIdentifierInCategory(category) {
    const url = `${loginUrl}/api/WBApps/getHighestUsedIdentifierInCategory`;
    return utils.get(url, [{ key: "algorithmCategory", value: category }]);
  },
  getAppByAlgorithmKey(algorithmKey) {
    const url = `${loginUrl}/api/WBApps/getAppByAlgorithmKey`;
    return utils.get(url, [{ key: "algorithmKey", value: algorithmKey }]);
  },
  resetAuth0Credentials(userId) {
    const url = `${apiUrl}/api/WBUsers/resetAuth0Secret`;
    return utils.post(url, [], { userId });
  },
  getAuthConfigs() {
    const url = `${apiUrl}/api/AuthConfigs`;
    return utils.get(url, []);
  },
  updateAuthConfig(data) {
    const url = `${apiUrl}/api/AuthConfigs`;
    return utils.put(url, [], data);
  },
  deleteAuthConfig(id) {
    const url = `${apiUrl}/api/AuthConfigs/${id}`;
    return utils.delete(url, []);
  },
  saveAuthConfig(data) {
    const url = `${apiUrl}/api/AuthConfigs`;
    return utils.post(url, [], data);
  },
  registerAuthConfigs(id) {
    const url = `${apiUrl}/api/AuthConfigs/register`;
    return utils.post(url, [], { id });
  },
  getSsoOptions() {
    const url = `${apiUrl}/api/AuthConfigs/getList`;
    return utils.get(url, []);
  },
};



// WEBPACK FOOTER //
// ./src/helpers/managedata.js